import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Cut = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Cut" {...props}>
    <path fillRule="evenodd" clipRule="evenodd" d="M5 2C7.20914 2 9 3.79086 9 6C9 6.46763 8.91798 6.91588 8.77051 7.33301L13.0908 10.7275L21.3818 4.21387L22.6182 5.78613L14.709 12L22.6182 18.2139L21.3818 19.7861L13.0908 13.2715L8.77051 16.666C8.91817 17.0834 9 17.532 9 18C9 20.2091 7.20914 22 5 22C2.79086 22 1 20.2091 1 18C1 15.7909 2.79086 14 5 14C6.01608 14 6.94288 14.3798 7.64844 15.0039L11.4717 12L7.64844 8.99512C6.94282 9.61953 6.01631 10 5 10C2.79086 10 1 8.20914 1 6C1 3.79086 2.79086 2 5 2ZM5 16C3.89543 16 3 16.8954 3 18C3 19.1046 3.89543 20 5 20C6.10457 20 7 19.1046 7 18C7 16.8954 6.10457 16 5 16ZM5 4C3.89543 4 3 4.89543 3 6C3 7.10457 3.89543 8 5 8C6.10457 8 7 7.10457 7 6C7 4.89543 6.10457 4 5 4Z" fill="#000" />
  </StyledIcon>
));

Cut.displayName = 'Cut';

export { Cut };
